export const STEP_ID_MAP = {
  allLocationList: "allLocationList",
  addNewLocation: "addNewLocation",
  editSortPreference: "editSortPreference",
  filteredLocationList: "filteredLocationList",
  groupedLocationList: "groupedLocationList"
};
